module.exports = __webpack_public_path__ + "img/Vina.ed3b9b83.jpeg";